import { JSX } from "react";

interface Props {
    title?: string;
    content?: string;
    small?: boolean;
}

export const ShowEstablishmentDetailsItem = (props: Props): JSX.Element => {
    return (
        <div className="p-show-establishment-details__content__data-group">
            <p
                className={`p-show-establishment-details__content__label ${props.small ? "p-show-establishment-details__content__label--small" : ""}`}
            >
                {props.title}:
            </p>
            <p className="p-show-establishment-details__content__value">
                {props.content ? props.content : "-"}
            </p>
        </div>
    );
};
